export const services = [
  {
    id: 'editorial',
    index: '01',
    name: 'Editorial & Campaign',
    description: 'Magazine stories and seasonal campaigns with full production, casting and usage.',
    included: ['Creative concept', 'Casting & crew', '20–60 finals'],
    price: 'From €850',
    tone: 'primary',
    icon: 'ri-camera-3-line',
  },
  {
    id: 'portrait',
    index: '02',
    name: 'Portrait Sessions',
    description: 'Natural, flattering portraits for talent, founders and personal brands.',
    included: ['Half-day session', 'Studio or location', '8 retouched finals'],
    price: 'From €420',
    tone: 'accent',
    icon: 'ri-user-smile-line',
  },
  {
    id: 'brand',
    index: '03',
    name: 'Brand & Lifestyle',
    description: 'Content that sells — people, product and place for web, social and ads.',
    included: ['Shot list planning', 'Social-ready crops', '40+ finals'],
    price: 'From €1,200',
    tone: 'secondary',
    icon: 'ri-sun-line',
  },
  {
    id: 'beauty',
    index: '04',
    name: 'Beauty & Detail',
    description: 'Skin, texture and close-ups with precise light and clean retouching.',
    included: ['Studio lighting', 'Macro detail work', 'High-end retouch'],
    price: 'From €700',
    tone: 'primary',
    icon: 'ri-drop-line',
  },
  {
    id: 'direction',
    index: '05',
    name: 'Creative Direction',
    description: 'Moodboards, casting and art direction for teams who need a clear vision.',
    included: ['Visual strategy', 'Moodboard & treatment', 'On-set direction'],
    price: 'On request',
    tone: 'accent',
    icon: 'ri-palette-line',
  },
];

export const projectTypes = ['Editorial & Campaign', 'Portrait Sessions', 'Brand & Lifestyle', 'Beauty & Detail', 'Creative Direction', 'Other'];